import { FieldOption } from './accountTypes'

const videoProviders: FieldOption[] = [
  { value: 'youtube', name: 'YouTube' },
  { value: 'vimeo', name: 'Vimeo' }
]

export default videoProviders
